export const baseURL = "https://backend.porchetube.com/";
export const secretKey = "!0abed^h+^kc81h3iqr$sfi9enyc05@zta3kke!3(46zyjej=";
export const projectName = "PorcheTube";
export const folderStructurePath = "Porchetube";